import { useNavigate } from 'react-router';
import { ReactComponent as LogOutIcon } from '../../../assets/icons/logout.svg';
import './UserCard.scss';
import { clearTokens } from '../../../utils';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import UserIcon from '../../../assets/icons/User.svg';
import { UserRoleEnum } from '../../../types/apiGeneratedTypes';

type UserCardProps = {
};

const UserCard: React.FC<UserCardProps> = () => {
  const adminInfo = useSelector((state: RootState) => state.admin);

  const navigate = useNavigate();

  const onLogOut = () => {
    clearTokens();
    navigate('/admin/87431/login');
  };

  return (
    <div className='user-card-container'>
      <div className='d-flex user-info-wrapper'>
        <div 
        className='user-info-left'>
          <div className='user-avatar'>
            <img src={UserIcon} alt='user' />
          </div>
          <div className='user-info'>
            <div className='user-name'>{`${adminInfo.admin.first_name} ${adminInfo.admin.last_name}`}</div>
            <div className='user-role'>
              {adminInfo.admin.role === UserRoleEnum.SuperAdmin
                ? 'Super Admin'
                : 'Administrator'}
            </div>
          </div>
        </div>
        <div onClick={onLogOut} className='logout-btn' title='Log Out'>
          <LogOutIcon width={25} height={25} />
        </div>
      </div>
    </div>
  );
};

export default UserCard;
